module.exports = "<p>\n  cronjob works!\n</p>\n"